import {LenderPassbookRecord} from '../../model/lender-passbook-record';
import {DataSourceFilter} from '../../portfolio-creation/manualinvest/filters/data-source.filter';
import { Injectable } from "@angular/core";
import * as moment from 'moment';

@Injectable()
export class PassbookDateRangeFilter extends DataSourceFilter {
    identifier(): string {
        return 'PassbookDateRangeFilter';
    }

    onFilterApplied(data: LenderPassbookRecord, {fromDate, toDate}: { fromDate: Date, toDate: Date }): boolean {
        return moment(data.timestamp).isBetween(moment(fromDate), moment(toDate), 'day', '[]');
    }
}
